export default theme => ({
	closeIcon: {
		padding: 0
	}
});
